module.exports = __webpack_public_path__ + "clippy_frame-3446d4d28d72aef2f64f7fabae30eb4a.png";